import React from "react";
import { connect } from "react-redux";
import { Modal, List, Icon, Alert, message, Button, Row, Col } from "antd";
import CaseService from "services/case-service";

const ProceedChecklist = function () {
    return (stageName, caseId, companyId, are_sellers_same, caseDetail) => {
        const ProceedChecklistWrapped = props => {
            const WrappedComponent = connect(
                state => {
                    return (
                        ProceedChecklist &&
                        ProceedChecklist.checklist &&
                        ProceedChecklist.checklist.getIn([
                            stageName,
                            "mapStateToProps"
                        ])(state, caseId, companyId, are_sellers_same, caseDetail)
                    );
                },
                null
            )(
                class ProceedChecklistWrapper extends React.Component {

                    notifyTeam = () => {
                        CaseService.confirmDistributorScheme(caseId).then(() => {
                            message.success("Team has been notified");
                        }).catch(() => {
                            message.error("Failed to Notify. Please Try Again");
                        });
                    }

                    showEvaluationModal(evaluation, passed, args) {
                        if (!evaluation || !evaluation.size) {
                            return props.onClick(args);
                        }
                        let showDocAlert = false;
                        let documentMessage = null;
                        console.log("evaluation", evaluation);
                        const isDocumentReviewed = evaluation.find((_, k) => k === "all_documents_reviewed_v2");
                        
                        if(isDocumentReviewed){
                            if(!isDocumentReviewed.value){
                                documentMessage = "Please approve all mandatory and requested documents";
                                showDocAlert = true;   
                            }
                        }
                        // if (isDocumentReviewed) {
                        //     if (isDocumentReviewed && !isDocumentReviewed.check) {
                        //         const { isRequested, isPendingApproval } = isDocumentReviewed.value;
                        //         if (isRequested && isPendingApproval) {
                        //             documentMessage = "Some of the documents are in 'Pending review' or 'Requested', please either approve, reject or delete those";
                        //         }
                        //         else if (isRequested && !isPendingApproval) {
                        //             documentMessage = "Please remove documents from 'Requested' tab to proceed if received already";
                        //         } else {
                        //             documentMessage = "Some of the documents are in 'Pending review', please either approve, reject or delete those";
                        //         }
                        //         showDocAlert = true;
                        //     }
                        // }

                        const sellerConfirmation = evaluation.find((_, k) =>
                            k === "is_seller_key_details_available"
                        );
                        const schemeConfirmation = evaluation.find((_, k) =>
                            k === "is_scheme_added"
                        );
                        const schemeCreatedOnLms = evaluation.find((_, k) =>
                            k === "is_scheme_created_on_lms"
                        );
                        let showSellerNotifyBtn = null;
                        if (
                            (sellerConfirmation && !sellerConfirmation.check) ||
                            (schemeConfirmation && !schemeConfirmation.check) ||
                            (schemeCreatedOnLms && !schemeCreatedOnLms.check)
                        ) {
                            showSellerNotifyBtn = true;
                        } else {
                            showSellerNotifyBtn = false;
                        }

                        const groupedList = evaluation.toList().sortBy(_ => !_.check).groupBy((_, index) => Math.floor(index / 7));
                        Modal.info({
                            title: "Proceed Checklist",
                            icon: passed ? (
                                <Icon type="check-circle" theme={"filled"} />
                            ) : null,
                            onOk: () => (passed && are_sellers_same ? props.onClick(args) : null),
                            okText: (passed && are_sellers_same ? "Proceed" : "Review Case"),
                            okButtonProps: {
                                type: passed && are_sellers_same ? "primary" : "default"
                            },
                            width: groupedList.size * 400,
                            content: (
                                <React.Fragment>
                                    <Row>
                                        {
                                            groupedList.map((list, keyIndex) =>
                                                <Col span={Math.floor(24 / groupedList.size)} key={keyIndex} className={"px-10"}>
                                                    <List>
                                                        {list
                                                            .map((_, key) => (
                                                                <List.Item key={key}>
                                                                    <List.Item.Meta
                                                                        title={_.label}
                                                                    />
                                                                    <Icon
                                                                        type={
                                                                            _.check
                                                                                ? "check-circle"
                                                                                : null
                                                                        }
                                                                        theme={"filled"}
                                                                        style={{
                                                                            fontSize: "18px",
                                                                            color: "#246079"
                                                                        }}
                                                                    />
                                                                </List.Item>
                                                            ))
                                                            .toArray()}
                                                    </List>
                                                </Col>).toList().toArray()
                                        }
                                    </Row>
                                    {showDocAlert && documentMessage ?
                                        (
                                            <Alert message={documentMessage} />
                                        ) : null
                                    }
                                    {showSellerNotifyBtn ?
                                        <Button onClick={this.notifyTeam} block type={"primary"}>
                                            {"Notify Bussiness Development Team"}
                                        </Button>
                                        : null
                                    }
                                    {!are_sellers_same ?
                                        (
                                            <Alert message={"Case Sellers are not same as Supplychain Sellers. Either add Supplychain entry in Update Case Details or Add Sellers. All Sellers that are in Supplychain must be added as Sellers in Case Details as well"} />
                                        )
                                        : null
                                    }
                                </React.Fragment>
                            )
                        });
                    }
                    isChecklistPassed(...args) {
                        if (ProceedChecklist.checklist) {
                            const evaluation = ProceedChecklist.checklist.getIn(
                                [stageName, "evaluator"]
                            )(this.props);
                            let filterEvaluation;
                            if(caseDetail.toJS()?.is_bnpl_case){
                                filterEvaluation = evaluation;
                            }else{
                                filterEvaluation = evaluation.delete("termLoan");
                            }
                            if (
                                filterEvaluation.reduce(
                                    (agg, curr) => agg && curr.check,
                                    true
                                )
                            ) {
                                this.showEvaluationModal(
                                    filterEvaluation,
                                    true,
                                    args
                                );
                                return true;
                            }
                            this.showEvaluationModal(filterEvaluation, false);
                        }
                        return false;
                    }
                    onClick = (...args) => {
                        this.isChecklistPassed(...args);
                    };
                    render() {
                        return ProceedChecklist.Component ? (
                            <ProceedChecklist.Component
                                {...props}
                                onClick={this.onClick}
                            />
                        ) : null;
                    }
                    static displayName = "ProceedChecklist";
                }
            );
            return <WrappedComponent {...props} />;
        };
        return ProceedChecklistWrapped;
    };
};
ProceedChecklist.registerComponent = function (Component) {
    this.Component = Component;
};
ProceedChecklist.registerChecklist = function (stageChecklist) {
    this.checklist = stageChecklist;
}
export default ProceedChecklist;
